export type GuideDifficulty = "easy" | "medium" | "advanced";

export type GuideTopicCard = {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  color: string | null;
  heroImageUrl: string | null;
  guideCount: number;
};

export type GuideProductCard = {
  id: string;
  kind: "affiliate" | "shop";
  role: "used" | "recommended";
  position: number;
  note: string | null;
  title: string;
  brand: string | null;
  description: string | null;
  imageUrl: string | null;
  href: string;
  discountCode: string | null;
  priceLabel: string | null;
  openInNewTab: boolean;
};

export type GuideCard = {
  id: string;
  slug: string;
  topic: { id: string; slug: string; name: string };
  title: string;
  subtitle: string | null;
  heroImageUrl: string | null;
  durationMins: number | null;
  difficulty: GuideDifficulty | null;
  productCount: number;
  likeCount: number;
  featured: boolean;
  publishedAt: string | null;
};

export type GuideDetail = {
  id: string;
  slug: string;
  title: string;
  subtitle: string | null;
  heroImageUrl: string | null;
  videoYoutubeId: string | null;
  videoInstagramUrl: string | null;
  bodyMarkdown: string;
  durationMins: number | null;
  difficulty: GuideDifficulty | null;
  personalNote: string | null;
  seoTitle: string | null;
  seoDescription: string | null;
  publishedAt: string | null;
  featured: boolean;
  topic: { id: string; slug: string; name: string; color: string | null } | null;
  products: GuideProductCard[];
  likeCount: number;
  likedByViewer: boolean;
  related: GuideCard[];
};

export function difficultyLabel(d: GuideDifficulty | null): string | null {
  if (!d) return null;
  if (d === "easy") return "Easy";
  if (d === "medium") return "Medium";
  return "Advanced";
}

export function formatDuration(mins: number | null): string | null {
  if (!mins || mins < 1) return null;
  if (mins < 60) return `${mins} min`;
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return m === 0 ? `${h} hr` : `${h} hr ${m} min`;
}
